/*到款记录 */
import { $http, buildHeaders } from "./index";

//获取到账公式列表
export const bankcollected_list = (params) => {
  return $http.get("/admin/BankCollected/getReceived", { params });
};

//获取到账公式详情
export const bankcollected_detail = (id) => {
  return $http.get(
    "/admin/BankCollected/getReceivedDetail?bank_received_id=" + id,
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取到账公示认领记录
export const bankcollected_rllist = (id) => {
  return $http.get("/admin/BankCollected/index", {
    params: {
      limit: 0,
      sort_field: "create_time",
      sort_value: "desc",
      bank_received_id: id,
    },
  });
};

//到账公式认领
export const bankcollected_add = (data) => {
  return $http.post("/admin/BankCollected/add", data, {
    headers: buildHeaders(3),
  });
};

//获取余额认领列表
export const bankcollected_other = (params) => {
  return $http.get("/admin/BankCollected/other", { params });
};

//导出
export const bankcollected_export = (params) => {
  return $http.get("/admin/BankCollected/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//获取可认领的工资表
export const bankcollected_getpayroll = (params) => {
  return $http.get("/admin/BankCollected/getPayroll", { params });
};

//批量认领
export const bankcollected_addbatch = (data) => {
  return $http.post(
    "/admin/BankCollected/addBatch",
    {
      data: data,
    },
    {
      headers: buildHeaders(3),
    },
  );
};

//申请合并
export const bankcollected_merge = (data) => {
  return $http.post("/admin/BankCollected/applyMergeReceived", data, {
    headers: buildHeaders(3),
  });
};

//合并记录
export const bankcollected_mergelist = (params) => {
  return $http.get("/admin/BankCollected/getApplyMergeList", {
    params,
  });
};

//获取合并记录详情
export const bankcollected_mergedetail = (id) => {
  return $http.get("/admin/BankCollected/getApplyMergeDetail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//撤回
export const bankcollected_back = (data) => {
  return $http.post("/admin/BankCollected/backApplyMerge", data, {
    headers: buildHeaders(3),
  });
};

//导出
export const bankcollected_exportReceived = (params) => {
  return $http.get("/admin/BankCollected/exportReceived", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
